export default "__VITE_ASSET__CDMZYb7i__"